module.exports = __webpack_public_path__ + "static/img/2.3347125.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/xunlonggaoshou/2.jpg
// module id = v9OW
// module chunks = 1